<script setup lang="ts">
import {reactive, ref} from "vue";
import {ElNotification} from "element-plus";
import {SectionService} from "@/api/api.ts";
import {getFileSize} from "@/utils/common.ts";
import {UploadedCourseFile} from "@/types";

const visible = ref(false)
const content = ref('')
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})
const fileList = ref<UploadedCourseFile[]>([])

const getFileList = async () => {
  try {
    const res = await SectionService.getUploadedFile({
      page: pagination.current,
      pageSize: pagination.pageSize,
      content: content.value
    })
    if (res.data.code === 200) {
      pagination.total = res.data.data?.count || 0
      pagination.current = res.data.data?.page || 1
      fileList.value = res.data.data?.list || []
    } else {
      ElNotification.error({
        title: '获取课程列表失败',
        message: res.data.msg,
        type: 'error',
      })
    }
  } catch (e) {
    console.warn(e)
  }
}

const show = () => {
  visible.value = true
  getFileList()
}

const hide = () => {
  visible.value = false
}

const onClose = () => {
  content.value = ''
  pagination.current = 1
  pagination.pageSize = 10
  fileList.value = []
}

const emit = defineEmits(['on-select-file'])

const onSelectFile = (id: number, filename: string, url: string) => {
  emit('on-select-file', id, filename, url)
}

const onPreview = (url: string) => {
  window.open(url, '_blank')
}

const onPageChange = (page: number) => {
  pagination.current = page
  getFileList()
}

const onSizeChange = (pageSize: number) => {
  pagination.pageSize = pageSize
  getFileList()
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog v-model="visible" title="已上传文件列表" @close="onClose">
    <div class="flex items-center">
      <el-input style="width: 20rem" v-model="content" type="text" placeholder="请输入搜索内容" @change="getFileList"/>
      <el-button class="ml-1rem" type="primary" @click="getFileList">搜索</el-button>
    </div>
    <el-table :data="fileList" style="width: 100%" class="mt-1rem">
      <el-table-column prop="id" label="文件ID"></el-table-column>
      <el-table-column prop="name" label="文件名称"></el-table-column>
      <el-table-column prop="size" label="文件大小">
        <template #default="scope">
          {{ getFileSize(scope.row.size) }}
        </template>
      </el-table-column>
      <el-table-column prop="ext" label="文件类型">
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button
              type="primary"
              @click="onSelectFile(scope.row.id, scope.row.name, scope.row.url)">选择文件
          </el-button>
          <el-button
              type="info"
              @click="onPreview(scope.row.url)">预览
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="mt-1rem"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="prev, pager, next, jumper, ->, total, sizes"
        :current-page="pagination.current"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @current-change="onPageChange"
        @size-change="onSizeChange"/>
  </el-dialog>
</template>

<style scoped>
</style>
